import { Injectable } from '@angular/core';
import { Http,Headers } from '@angular/http';
import { ApplicationUrlSettings } from '../../settings/ApplicationUrlSettings';
import { AuthService } from '../auth-service/auth.service';

@Injectable()
export class DriverService {

  constructor(private http: Http) {

  }


  public getCompany(driverid,clientid = null): Promise<string> {
    
    if(!clientid){
      clientid = AuthService.getClientId();
    }
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    var url = `${ApplicationUrlSettings.NODE_API_URL}driver/company-locations?clientid=${clientid}&driverid=${driverid}`;
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }

  accept(driverid,clientid,access_string = null){
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.DRIVER}/accept-invite?driverid=${driverid}&clientid=${clientid}&access_string=${access_string}`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.patch(url,{},{headers:headers}).toPromise().then(res => res.json());
  }

  invite(payload){
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.DRIVER}/invite`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.post(url,payload,{headers:headers}).toPromise().then(res => res.json());
  }
  

  emailExist(email) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.DRIVER}/email-exist/${email}`;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  createDriver(body): Promise<string> {
    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.DRIVER;
    return this.http.post(url, JSON.stringify(body)).toPromise().then(res => res.json());
  }

  getVehicles(driverid) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vehicle/driver/${driverid}`;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  assignTrip(payload) {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    var url = `${ApplicationUrlSettings.NODE_API_URL}trip/accept`;
    return this.http.patch(url, payload, { headers: headers }).toPromise().then(res => res.json());
  }

  unassignTrip(tripid) {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    var url = `${ApplicationUrlSettings.NODE_API_URL}trip/unassign?id=${tripid}`;
    return this.http.patch(url, {}, { headers: headers }).toPromise().then(res => res.json());
  }

  getDrivers(id: number = null, options: { isPortal?: boolean } = {}): Promise<any> {
    var url = "";
    if (id) {
      url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.DRIVER + "/" + id;
    } else {
      url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.DRIVER;
      if (options && options.isPortal) {
        url += '?isPortal=true';
      }
    }
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.get(url,{ headers:headers}).toPromise().then(res => res.json());
  }

  /**
   * Normalize a row from GET /driver/ or GET /driver/?isPortal=true into UI driver shape.
   */
  normalizeDriverApiRow(row: any): any {
    if (!row) {
      return null;
    }
    const kindRaw = row.driver_kind != null ? row.driver_kind : row.type;
    const isPortal = kindRaw === 'portal' || row.isPortalDriver === true;
    if (isPortal) {
      const id = row.portal_driver_id != null ? row.portal_driver_id
        : (row.id != null ? row.id : row.driverid);
      if (id == null || id === '') {
        return null;
      }
      let firstname = row.firstname != null ? String(row.firstname) : '';
      let lastname = row.lastname != null ? String(row.lastname) : '';
      if (!firstname && !lastname && row.name != null) {
        const parts = String(row.name).trim().split(/\s+/).filter(Boolean);
        firstname = parts.length ? parts[0] : '';
        lastname = parts.length > 1 ? parts.slice(1).join(' ') : '';
      }
      return {
        firstname,
        lastname,
        email: row.email != null ? String(row.email) : '',
        phone: row.phone != null ? String(row.phone) : null,
        driverid: `portal_${id}`,
        portalDriverId: Number(id),
        isPortalDriver: true,
        portalActive: true,
        status: 'Portal',
        activeTrip: 'FREE',
        vehicleName: row.vehicle_name != null ? String(row.vehicle_name)
          : (row.vehicleName != null ? String(row.vehicleName) : ''),
        clientid: row.clientid != null ? row.clientid : undefined,
        driver_kind: 'portal'
      };
    }
    return Object.assign({}, row, {
      isPortalDriver: false,
      driver_kind: kindRaw || 'driver'
    });
  }

  mapDriverApiResponse(res: any): any[] {
    if (!res) {
      return [];
    }
    const rows = res.data != null ? res.data : (Array.isArray(res) ? res : []);
    if (!Array.isArray(rows)) {
      return [];
    }
    return rows.map(r => this.normalizeDriverApiRow(r)).filter(x => x != null);
  }

  registerDriver(payload){
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.DRIVER;
    return this.http.post(url, payload).toPromise().then(res => res.json());
  }

  sendLocation(payload){
    var url = `${ApplicationUrlSettings.NODE_API_URL}driver/location`;
    return this.http.post(url,payload).toPromise().then(res => res.json())
  }

  getDriversInfo(){
    var url = `${ApplicationUrlSettings.NODE_API_URL}driver/info`
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.get(url,{ headers:headers}).toPromise().then(res => res.json());
  }

  /**
   * Portal-only drivers (no mobile app).
   * @param includeDeleted When true, adds include_deleted=1 so soft-deleted rows are returned (each row has active true/false).
   */
  getPortalDrivers(includeDeleted: boolean = false): Promise<any> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    let url = `${ApplicationUrlSettings.NODE_API_URL}driver/portal-drivers`;
    const query: string[] = [];
    const clientid = AuthService.getClientId();
    if (clientid != null && clientid !== undefined && clientid !== '') {
      query.push(`clientid=${encodeURIComponent(clientid)}`);
    }
    if (includeDeleted) {
      query.push('include_deleted=1');
    }
    if (query.length) {
      url += `?${query.join('&')}`;
    }
    return this.http.get(url, { headers }).toPromise().then(res => res.json());
  }

  createPortalDriver(body: any): Promise<any> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    });
    const url = `${ApplicationUrlSettings.NODE_API_URL}driver/portal-drivers`;
    const payload = Object.assign({}, body);
    if (payload.clientid == null && AuthService.getClientId() != null) {
      payload.clientid = AuthService.getClientId();
    }
    return this.http.post(url, payload, { headers }).toPromise().then(res => res.json());
  }

  removePortalDriver(portalDriverId: number): Promise<any> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    const url = `${ApplicationUrlSettings.NODE_API_URL}driver/portal-drivers/${portalDriverId}`;
    return this.http.delete(url, { headers }).toPromise().then(res => res.json());
  }

  /** Reactivate a soft-deleted portal driver (clears deleted_at). */
  reactivatePortalDriver(portalDriverId: number): Promise<any> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    });
    const url = `${ApplicationUrlSettings.NODE_API_URL}driver/portal-drivers/${portalDriverId}`;
    return this.http.patch(url, { active: true }, { headers }).toPromise().then(res => res.json());
  }

  /**
   * Portal driver company access (same response shape as GET /driver/company-locations).
   * Super: pass clientid query when needed (e.g. portal row’s client).
   */
  getPortalDriverCompanyLocations(portalDriverId: number, clientid: any = null): Promise<any> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    let url = `${ApplicationUrlSettings.NODE_API_URL}driver/portal-drivers/${portalDriverId}/company-locations`;
    if (clientid != null && clientid !== undefined && clientid !== '' && clientid !== 'none') {
      url += `?clientid=${encodeURIComponent(clientid)}`;
    }
    return this.http.get(url, { headers }).toPromise().then(res => res.json());
  }

  /** Clients/providers linked to a platform driver (GET /driver/providers?driverid=). */
  getDriverProviders(driverid: any): Promise<any> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    const url = `${ApplicationUrlSettings.NODE_API_URL}driver/providers?driverid=${encodeURIComponent(String(driverid))}`;
    return this.http.get(url, { headers }).toPromise().then(res => res.json());
  }

  /** Remove platform driver from one client without removing other client links. */
  unassignDriverFromClient(driverid: number, clientid: number): Promise<any> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    const url = `${ApplicationUrlSettings.NODE_API_URL}driver/unassign-client?driverid=${encodeURIComponent(String(driverid))}&clientid=${encodeURIComponent(String(clientid))}`;
    return this.http.delete(url, { headers }).toPromise().then(res => res.json());
  }

  /** Link platform driver to a client (creates or restores client_driver). */
  assignDriverToClient(driverid: number, clientid: number): Promise<any> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    const url = `${ApplicationUrlSettings.NODE_API_URL}driver/assign-client?driverid=${encodeURIComponent(String(driverid))}&clientid=${encodeURIComponent(String(clientid))}`;
    return this.http.post(url, {}, { headers }).toPromise().then(res => res.json());
  }

  /** Portal: remove from client entirely (hard remove — not listed under Deleted drivers). */
  unassignPortalDriverFromClient(portalDriverId: number, clientid: number | string | null = null): Promise<any> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    let url = `${ApplicationUrlSettings.NODE_API_URL}driver/portal-drivers/${encodeURIComponent(String(portalDriverId))}/unassign-from-client`;
    if (clientid != null && clientid !== '' && clientid !== 'none') {
      url += `?clientid=${encodeURIComponent(String(clientid))}`;
    }
    return this.http.delete(url, { headers }).toPromise().then(res => res.json());
  }

  /** Companies for a known client+driver (requires clientid). Prefer getDriverProviders to discover clients. */
  getDriverClientCompany(driverid: any, clientid: any = null): Promise<any> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    let url = `${ApplicationUrlSettings.NODE_API_URL}driver/client-company?driverid=${encodeURIComponent(String(driverid))}`;
    if (clientid != null && clientid !== undefined && clientid !== '' && clientid !== 'none') {
      url += `&clientid=${encodeURIComponent(String(clientid))}`;
    }
    return this.http.get(url, { headers }).toPromise().then(res => res.json());
  }

  /** Companies linked to portal driver (same idea as GET /driver/client-company). */
  getPortalDriverClientCompany(portalDriverId: number, clientid: any = null): Promise<any> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    let url = `${ApplicationUrlSettings.NODE_API_URL}driver/portal-drivers/${portalDriverId}/client-company`;
    if (clientid != null && clientid !== undefined && clientid !== '' && clientid !== 'none') {
      url += `?clientid=${encodeURIComponent(clientid)}`;
    }
    return this.http.get(url, { headers }).toPromise().then(res => res.json());
  }

  assignPortalCompanyLocation(portalDriverId: number, companyid: number, locationid: number, clientid: any = null): Promise<any> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    });
    let url = `${ApplicationUrlSettings.NODE_API_URL}driver/portal-drivers/${portalDriverId}/company-locations/assign`;
    if (clientid != null && clientid !== undefined && clientid !== '' && clientid !== 'none') {
      url += `?clientid=${encodeURIComponent(clientid)}`;
    }
    const body = { companyid, locationid };
    return this.http.post(url, body, { headers }).toPromise().then(res => res.json());
  }

  unassignPortalCompanyLocation(portalDriverId: number, companyid: number, locationid: number, clientid: any = null): Promise<any> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    let url = `${ApplicationUrlSettings.NODE_API_URL}driver/portal-drivers/${portalDriverId}/company-locations/unassign?companyid=${companyid}&locationid=${locationid}`;
    if (clientid != null && clientid !== undefined && clientid !== '' && clientid !== 'none') {
      url += `&clientid=${encodeURIComponent(clientid)}`;
    }
    return this.http.delete(url, { headers }).toPromise().then(res => res.json());
  }

  updatePortalDriver(portalDriverId: number, body: any): Promise<any> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    });
    const url = `${ApplicationUrlSettings.NODE_API_URL}driver/portal-drivers/${portalDriverId}`;
    const payload = Object.assign({}, body);
    if (payload.clientid == null && AuthService.getClientId() != null) {
      payload.clientid = AuthService.getClientId();
    }
    return this.http.patch(url, payload, { headers }).toPromise().then(res => res.json());
  }

  /**
   * Merged soft-deleted portal drivers + inactive platform drivers for the scoped client(s).
   */
  getDeletedDrivers(): Promise<any> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    let url = `${ApplicationUrlSettings.NODE_API_URL}driver/deleted-drivers`;
    const clientid = AuthService.getClientId();
    if (clientid != null && clientid !== undefined && clientid !== '') {
      url += `?clientid=${encodeURIComponent(clientid)}`;
    }
    return this.http.get(url, { headers }).toPromise().then(res => res.json());
  }

  /** Reactivate a deleted portal row or an inactive platform driver. */
  reactivateDeletedDriver(body: { driver_kind: string; id: number }): Promise<any> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    });
    const url = `${ApplicationUrlSettings.NODE_API_URL}driver/deleted-drivers/reactivate`;
    const payload = { driver_kind: body.driver_kind, type: body.driver_kind, id: body.id };
    return this.http.post(url, payload, { headers }).toPromise().then(res => res.json());
  }

  normalizeDeletedDriverRow(row: any): any {
    const kindRaw = row.driver_kind != null ? row.driver_kind : row.type;
    const kind = kindRaw === 'driver' ? 'driver' : 'portal';
    const id = row.id != null ? Number(row.id) : NaN;
    if (Number.isNaN(id)) {
      return null;
    }
    const isPortal = kind === 'portal';
    const firstname = row.firstname != null ? String(row.firstname) : '';
    const lastname = row.lastname != null ? String(row.lastname) : '';
    const vehicleRaw = row.vehicle_name != null ? row.vehicle_name : row.vehicleName;
    const vehicleName = isPortal && vehicleRaw != null ? String(vehicleRaw) : '';
    const driveridNum = row.driverid != null ? Number(row.driverid) : id;
    return {
      firstname,
      lastname,
      email: row.email != null ? String(row.email) : '',
      phone: row.phone != null ? String(row.phone) : null,
      driverid: isPortal ? `portal_${id}` : driveridNum,
      isPortalDriver: isPortal,
      portalActive: false,
      portalDriverId: isPortal ? id : undefined,
      deletedDriverKind: kind,
      deletedReactivateId: id,
      fromDeletedDriversApi: true,
      status: 'Removed',
      active: false,
      activeTrip: 'FREE',
      vehicleName,
      pic: row.pic,
      contractor: row.contractor,
      clientid: row.clientid
    };
  }

  mapDeletedDriversResponse(res: any): any[] {
    if (!res) {
      return [];
    }
    const rows = res.data != null ? res.data : (Array.isArray(res) ? res : []);
    if (!Array.isArray(rows)) {
      return [];
    }
    return rows.map(r => this.normalizeDeletedDriverRow(r)).filter(x => x != null);
  }

  normalizePortalDriverRow(row: any): any {
    const id = row.id != null ? row.id : row.portal_driver_id;
    if (id == null) {
      return null;
    }
    const firstname = row.firstname != null ? String(row.firstname) : '';
    const lastname = row.lastname != null ? String(row.lastname) : '';
    const portalActive = row.active !== false && row.active !== 0 && row.active !== 'false';
    return {
      firstname,
      lastname,
      email: row.email != null ? String(row.email) : '',
      phone: row.phone != null ? String(row.phone) : null,
      driverid: `portal_${id}`,
      portalDriverId: Number(id),
      isPortalDriver: true,
      portalActive,
      status: portalActive ? 'Portal' : 'Removed',
      activeTrip: 'FREE',
      vehicleName: row.vehicle_name != null ? row.vehicle_name : (row.vehicleName != null ? row.vehicleName : ''),
      clientid: row.clientid != null ? row.clientid : undefined
    };
  }

  mapPortalDriversResponse(res: any): any[] {
    if (!res) {
      return [];
    }
    const rows = res.data != null ? res.data : (Array.isArray(res) ? res : []);
    if (!Array.isArray(rows)) {
      return [];
    }
    return rows.map(r => this.normalizePortalDriverRow(r)).filter(x => x != null);
  }

  removeDriver(driverid){
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    var url = `${ApplicationUrlSettings.NODE_API_URL}driver/remove-driver?driverid=${driverid}`;
    return this.http.delete(url,{ headers: headers }).toPromise().then(res => res.json());
  }

  updateDriverPhone(phone: string, driverId: number): Promise<any> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    });
    const url = `${ApplicationUrlSettings.NODE_API_URL}driver/phone`;
    return this.http.patch(url, { phone: phone, driverId: driverId }, { headers: headers }).toPromise().then(res => res.json());
  }

  unassignCompanyLocations(driverid,companyid,locationid,clientid = null){
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    var url = `${ApplicationUrlSettings.NODE_API_URL}driver/company-locations/unassign?driverid=${driverid}&companyid=${companyid}&locationid=${locationid}`;
    if(clientid){
      url += `&clientid=${clientid}`
    }
    return this.http.delete(url,{ headers: headers }).toPromise().then(res => res.json());
  }

  assignCompanyLocation(driverid,companyid,locationid,clientid = null){
    var payload = {
      driverid:driverid,
      companyid:companyid,
      locationid:locationid
    }
    var url = `${ApplicationUrlSettings.NODE_API_URL}driver/company-locations/assign`
    if(clientid){
      url += `?clientid=${clientid}`
    }
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.post(url,payload,{ headers:headers}).toPromise().then(res => res.json())
  }

  // Driver Pay Plan Methods
  
  /**
   * Get pay plan settings for a specific driver
   * @param driverId - The driver ID
   * @param clientId - Optional client ID (defaults to current client)
   */
  getDriverPayPlan(driverId: number, clientId: number = null): Promise<any> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    
    let url = `${ApplicationUrlSettings.NODE_API_URL}driver/driver-pay-plans?driverid=${driverId}`;
    if (clientId) {
      url += `?clientid=${clientId}`;
    }
    
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }

  /**
   * Save pay plan settings for a driver
   * @param payPlanData - Object containing pay plan settings
   */
  saveDriverPayPlan(payPlanData: {
    driverId: number;
    payPlanType: string;
    flatAmount?: number;
    ratePercentage?: number;
    clientId?: number;
  }): Promise<any> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    });
    
    let url = `${ApplicationUrlSettings.NODE_API_URL}driver/driver-pay-plans`;
    if (payPlanData.clientId) {
      url += `?clientid=${payPlanData.clientId}`;
    }
    
    return this.http.post(url, payPlanData, { headers: headers }).toPromise().then(res => res.json());
  }
}
